import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
export enum AllInvoiceReportFields {
  id = 'id',
  transactionDate = 'transactionDate',
  paymentStatus = 'paymentStatus',
  totalAmount = 'totalAmount',
  firstName = 'firstName',
  lastName = 'lastName',
  fullName = 'fullName',
  suffix = 'suffix',
  prefix = 'prefix',
  orderNumber = 'orderNumber',
  numberOfItems = 'numberOfItems',
  completionDate = 'completionDate',
  paymentType = 'paymentType',
  creditCardType = 'creditCardType',
  creditCardLastFour = 'creditCardLastFour',
  nameOnCheck = 'nameOnCheck',
  checkNumber = 'checkNumber'
}

export const AllInvoiceReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(AllInvoiceReportFields.transactionDate, '', 'Transaction Date'),
  new ItemPickerModel(AllInvoiceReportFields.paymentStatus, '', 'Payment Status'),
  new ItemPickerModel(AllInvoiceReportFields.totalAmount, '', 'Total Amount'),
  new ItemPickerModel(AllInvoiceReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(AllInvoiceReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(AllInvoiceReportFields.fullName, '', 'Full Name'),
  new ItemPickerModel(AllInvoiceReportFields.suffix, '', 'Suffix'),
  new ItemPickerModel(AllInvoiceReportFields.prefix, '', 'Prefix'),
  new ItemPickerModel(AllInvoiceReportFields.orderNumber, '', 'Order Number'),
  new ItemPickerModel(AllInvoiceReportFields.numberOfItems, '', 'Number of Items'),
  new ItemPickerModel(AllInvoiceReportFields.completionDate, '', 'Completion Date'),
  new ItemPickerModel(AllInvoiceReportFields.paymentType, '', 'Payment Type'),
  new ItemPickerModel(AllInvoiceReportFields.creditCardType, '', 'Credit Card Type'),
  new ItemPickerModel(AllInvoiceReportFields.creditCardLastFour, '', 'Credit Card Last 4 Digits'),
  new ItemPickerModel(AllInvoiceReportFields.nameOnCheck, '', 'Name on Check'),
  new ItemPickerModel(AllInvoiceReportFields.checkNumber, '', 'Check Number')
];
